<div class="rateAuditSummaryGrid">
    <kendo-grid id="kendoGrid" [data]="view" [pageSize]="pageSize" [height]="500" [sort]="state.sort" [sortable]="true"
        [scrollable]="'scrollable'" (dataStateChange)="dataStateChange($event)">
        <kendo-grid-column title="" [width]="10">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <ngl-checkbox>
                    <input ngl type="checkbox" [(ngModel)]="dataItem.checked" name="dataItem.name" />
                </ngl-checkbox>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Audit ID" [width]="20">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{dataItem.QuickAuditID ? dataItem.QuickAuditID : dataItem.UniversalAuditID}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="CustomerAccountName" title="Account" [width]="40">
        </kendo-grid-column>
        <kendo-grid-column field="ContractYear" title="Contract Year" [width]="20">
        </kendo-grid-column>
        <kendo-grid-column field="AuditAmadeus" title="Audit Amadeus" [width]="20">
        </kendo-grid-column>
        <kendo-grid-column field="AuditApollo" title="Audit Apollo" [width]="20">
        </kendo-grid-column>
        <kendo-grid-column field="AuditGalileo" title="Audit Galileo" [width]="20">
        </kendo-grid-column>
        <kendo-grid-column field="AuditSabre" title="Audit Sabre" [width]="20">
        </kendo-grid-column>
        <kendo-grid-column field="AuditWorldspan" title="Audit Worldspan" [width]="30">
        </kendo-grid-column>
    </kendo-grid>
</div>

<div kendoDialogContainer *ngIf='kendoDialog'></div>

<div class="summary-div">
    <span class="summary-div-warning">Select up to 200 jobs that you wish to include in the summary report</span>
    <button class=" summary-div k-button cvt-primary cvt-kendobutton " (click)="OnBuildReport($event)">Build Summary
        Report</button>
</div>

<app-modal (onOkToParent)='okButtonClick()' (onCloseToParent)='closeModals()' *ngIf='openModal'
    [dialogTitle]="dialogTitle" [dialogTextLine1]="dialogTextLine1" [dialogTextLine2]="dialogTextLine2"
    [primaryButtonText]="primaryButtonText" [secondaryButtonText]="secondaryButtonText"></app-modal>
